import { render, staticRenderFns } from "./InventarioQualidade.vue?vue&type=template&id=dc016a62&scoped=true"
import script from "./InventarioQualidade.vue?vue&type=script&lang=js"
export * from "./InventarioQualidade.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=dc016a62&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc016a62",
  null
  
)

export default component.exports